import styled, { css } from 'styled-components';

import {
  background_01_1x1_a,
  background_01_4x3_a,
  background_01_7x2_a,
} from '@xing-com/background-images';
import { Section } from '@xing-com/layout-primitives';
import { mediaTiny, mediaWideNavless } from '@xing-com/layout-tokens';
import { xdlPaletteLime09 } from '@xing-com/tokens';

export const BackgroundSection = styled(Section)<{ spacious?: boolean }>`
  background-color: ${xdlPaletteLime09};
  background-image: url(${background_01_7x2_a});
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: 15%;

  @media ${mediaTiny} {
    background-image: url(${background_01_1x1_a});
    background-position-y: 77%;
  }

  @media ${mediaWideNavless} {
    background-size: 110%;
    background-position-x: 55%;
  }

  ${({ spacious }) =>
    spacious &&
    css`
      background-image: url(${background_01_4x3_a});

      @media ${mediaWideNavless} {
        background-image: url(${background_01_7x2_a});
        background-size: cover;
      }
    `};
`;
